import axios from '../../service/axios';

import {AccountService} from '../../service/AccountService';

export class LoginService extends AccountService {

  static login(userNameOrEmailAddress: string, password: string, rememberMe: boolean): Promise<any> {
    return axios.post(`${this.entity}/login`, {userNameOrEmailAddress, password, rememberMe}).then(res => res.data);
  }

  static logout(): Promise<any> {
    return axios.get(`${this.entity}/logout`).then(res => res.data);
  }

  static forgotPassword(email: string, taxCode: string): Promise<any> {
    return axios.post(`app/my-account/send-reset-password`, {email, taxCode}).then(res => res.data);
  }

}
